import { FaEyeSlash,FaEye } from 'react-icons/fa';
import { useState } from 'react'
import { useAuthContext } from '../hooks/useAuthContext';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { IoIosInformationCircleOutline } from "react-icons/io";


const Login = () => {

  const [security_key, setSecurity_key] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { dispatch } = useAuthContext();
  var json = ''

  const submitHandler = async (e) => {
    e.preventDefault() 

    const user = { security_key }
    setLoading(true)
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/login`, {

      method: 'POST',
      body: JSON.stringify(user),
      headers : {
        'Content-Type': 'application/json'
      }
    })
    setLoading(false);
    json = await response.json();
    notify();

    if(!response) {
      try {
        setError(json.error)
        console.log(error)
      } catch(e) {
        throw new Error(e)
      }
    }

    if(response.ok) {
      try {
        localStorage.setItem('user', JSON.stringify(json))
        dispatch({type: 'LOGIN', payload: json})
        setError(null);
        setSecurity_key('');
        console.log('Login Successfull!');
      } catch(e) {
        throw new Error(e)
      }
    }
    
  }

  const notify = () => {
    
    if(json.hasOwnProperty('error') === false) {
      toast.success('Login Successfull!')
    }
    else {
      toast.error(json.error)
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  return (
    <div className='h-[100vh] bg-center bg-stone-900 text-white flex flex-col gap-12 items-center justify-center'>
    <div className='bg-slate-200 text-stone-800 px-10 py-5 rounded-md rounded-bl-none flex justify-center items-center gap-1 cursor-pointer'>
      <IoIosInformationCircleOutline size={25} color='16A40C' />
      Please wait for 60 seconds as the server responds</div>
      <div className="border border-[#d9d9d9] p-10 rounded-lg bg-[#1f1f1f] w-3/4 flex flex-col gap-12 md:w-[400px]" >
        <div className='container relative w-full'>  
          <input type={showPassword ? 'text' : 'password'} className='w-full p-2 bg-transparent border rounded-md password-input-wrapper indent-[1rem]' placeholder='Password' onChange={(e)=>setSecurity_key(e.target.value)} value={security_key}/>
          <button
            className="absolute inset-y-0 right-0 flex items-center px-4 text-white"
            onClick={togglePasswordVisibility}
            >
            {!showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <button className='px-3 capitalize text-base bg-[#6637ED] h-8 rounded-md md:text-lg md:h-10' onClick={submitHandler} disabled={loading}>{loading ? <>Loading...</> : <>Login</>}</button>
        <ToastContainer theme="dark"/>
      </div>
    </div>
  )
}

export default Login
